import { render, staticRenderFns } from "./permohonan.vue?vue&type=template&id=3f56cdd0&"
import script from "./permohonan.vue?vue&type=script&lang=js&"
export * from "./permohonan.vue?vue&type=script&lang=js&"
import style0 from "./permohonan.vue?vue&type=style&index=0&id=3f56cdd0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports